import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CustomModalHeader from './CustomModalHeader';
import styles from './ExpectedWinInfoPopup.module.css';

interface ExpectedWinInfoPopupProps {
  show: boolean;
  onHide: () => void;
}

const ExpectedWinInfoPopup = ({ show, onHide }: ExpectedWinInfoPopupProps) => {
  return (
    <Modal show={show} onHide={onHide} dialogClassName={styles.modalWidth}>
      <CustomModalHeader />
      <div className={styles.content}>
        <h4>Expected Win %</h4>
        <h5>What is it?</h5>
        <p>
          An AI-based prediction of which team is likely to win the round based on the current situation.
        </p>
        <h5>How does it work?</h5>
        <p>
          The model was trained on over 500,000 publicly available professional Counter-Strike rounds. It analyzes the current game state (positions, health, equipment, time, bomb status) 
          and focuses purely on tactical factors, ignoring specific teams and players.
        </p>
        <h5>How accurate is it?</h5>
        <p>
          It is most accurate in common situations that occur frequently in professional matches. For unusual or rare scenarios, predictions may be less reliable. The model has decent overall accuracy, but we're always working to improve it. Please provide us feedback if you notice any issues!
        </p>
      </div>
      <div className={styles.footer}>
        <Button variant="primary" onClick={onHide}>
          <i className="bi bi-check2" style={{ marginRight: 10 }} />
          Got it
        </Button>
      </div>
    </Modal>
  );
};

export default ExpectedWinInfoPopup; 